import { render, staticRenderFns } from "./comprobante.agregar.detalle.vue?vue&type=template&id=72546e16&scoped=true&"
import script from "./comprobante.agregar.detalle.vue?vue&type=script&lang=js&"
export * from "./comprobante.agregar.detalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72546e16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
